/**
 * Vibration API wrapper with feature detection.
 * Works on Chrome Android. No-op on iOS Safari (no Vibration API).
 */

function vibrate(pattern: number | number[]): void {
  if ('vibrate' in navigator) {
    navigator.vibrate(pattern);
  }
}

/** Single 200ms buzz for wrong answers */
export function vibrateWrongAnswer(): void {
  vibrate(200);
}

/** Double tap pattern for quest completion */
export function vibrateSuccess(): void {
  vibrate([100, 50, 100]);
}
